import * as Sentry from "@sentry/browser";
export default defineNuxtPlugin((nuxtApp) => {
  const { public: publicConfig } = useRuntimeConfig();
  const { getUser } = useUserStore();

  if (publicConfig.nuxtEnv === "prod") {
    if ("email" in getUser) {
      Sentry.setUser({ email: getUser.email });
    }
  }
});
